// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card__vK-nN","qr-code":"index_qr-code__1-teh"};